import React from 'react';
import '../../views/Exponents/style_exponent.css';
import { Form, Input } from 'semantic-ui-react';

const Search = ({ searchTerm, onSearch }) => {
    return (
        <Form className="search-form">
            <Input
                type='search'
                placeholder='Введите запрос'
                name="search"
                className="search"
                value={searchTerm}
                onChange={onSearch}
                autoFocus={true}
            />
        </Form>
    );
};

export default Search;
